module.exports = __webpack_public_path__ + "img/269-1.7caf137b.jpg";